module.exports = __webpack_public_path__ + "static/media/0025_IMG_LES_MURS_PAPIER_BRIQUE_BLANCHE.48e11172.png";